if (!customElements.get('makri-tier-addon')) {
  customElements.define(
    'makri-tier-addon',
    class MakriTierAddon extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const button = event.target.closest('button.makri-tier-addon__add');
          if (button) this.add(button);
        });
      }

      async add(button) {
        if (button.disabled) return;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        const status = this.querySelector('[data-addon-status]');
        try {
          const url =
            window.routes && window.routes.cart_add_url ? `${window.routes.cart_add_url}.js` : '/cart/add.js';
          const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
              sections: 'cart-icon-bubble',
              sections_url: window.location.pathname,
            }),
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || response.status);

          const bubbleHtml = data.sections && data.sections['cart-icon-bubble'];
          const bubble = document.getElementById('cart-icon-bubble');
          if (bubbleHtml && bubble) {
            const fresh = new DOMParser()
              .parseFromString(bubbleHtml, 'text/html')
              .getElementById('shopify-section-cart-icon-bubble');
            if (fresh) bubble.innerHTML = fresh.innerHTML;
          }
          button.textContent = button.dataset.addedLabel;
          if (status) status.textContent = button.dataset.addedLabel;
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'makri-tier-addon', cartData: data });
          }
        } catch (error) {
          button.disabled = false;
          button.textContent = button.dataset.errorLabel;
          if (status) status.textContent = button.dataset.errorLabel;
        } finally {
          button.removeAttribute('aria-busy');
        }
      }
    }
  );
}
